<template>
    <div>
        <h2 class="page-header">Thank You for Choosing Switch Telecom</h2>

        <p>
        All applications are processed during normal office hours. If you have any questions please feel free to contact us,
        either telephonically on <a href="tel:0800060100" title="Switch Telecom Toll Free Telephone Number" class="text-dark font-weight-bold" target="_blank">0800 060 100</a>, or, via email: <a href="mailto:enquiries@switchtel.co.za" class="text-dark font-weight-bold">enquiries@switchtel.co.za</a>.
        </p>

        <p>We will be in touch shortly with an update on the progress of your application.</p>

    </div>
</template>

<script>

export default {
    name: "ThankYou",
  
    mounted() {
 
    },
    data() {
        return {}
           
    }, //end of data

    methods: {
        
    },
};
</script>
